

module.exports = {
  projectType: 'spa||0.0.0',
  projectId: 'cmsEmpSolucionesDigitales',
  versionJs: '0.1.32',
  headerInjection: true,
  footerInjection: true,
  devPublicPath: '',
  devCrossOriginLoading: 'use-credentials',
  qaPublicPath: 'https://qa.cms.col.movistar.es/app/emp/public/solucionesdigitales/',
  qaCrossOriginLoading: 'use-credentials',
  prodPublicPath: 'https://prod.cms.col.movistar.es/app/emp/public/solucionesdigitales/',
  prodCrossOriginLoading: false,
}
